module.exports = __webpack_public_path__ + "img/9788956372570.44755006.jpg";